export var pickerProps = {
  title: String,
  loading: Boolean,
  showToolbar: Boolean,
  cancelButtonText: String,
  confirmButtonText: String,
  visibleItemCount: {
    type: Number,
    default: 5
  },
  itemHeight: {
    type: Number,
    default: 44
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/es/picker/shared.js
// module id = null
// module chunks = 